// Shared by world.ts and levels.ts
import type { ObjData } from '../../core/types';

export const K = 'spaghetti';
export const DEG = Math.PI / 180;

// ---------- object data ----------
/**
 * A ball (or a helper) hanging from a hook (ax, ay) on a spaghetti string. ball = index in the level's balls (default 0).
 * cheese: a heavy parmesan lump hangs at (x, y) instead of a ball.
 */
export interface StringObj extends ObjData { ax: number; ay: number; cheese?: boolean; ball?: number }

// A string that holds a level ball has no x/y of its own (the ball has them); only the cheese lump has x/y
declare module '../../core/types' {
  interface ObjDataTypes { spaghetti_string: { ax: number; ay: number; cheese?: boolean; ball?: number; x?: number; y?: number } }
}
